'use client'

import { ReactNode } from 'react'
import { SWRConfig } from 'swr'

export function SWRProvider({ children }: { children: ReactNode }) {
  return (
    <SWRConfig
      value={{
        // Dedupe requests within 2 seconds (default is 2000ms, keeping it explicit)
        dedupingInterval: 2000,
        // Reduce revalidation to improve performance
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        // Keep data fresh but don't revalidate too aggressively
        revalidateIfStale: true,
        // Error retry with backoff
        errorRetryCount: 3,
        errorRetryInterval: 5000,
        // Performance optimization: suspense mode will batch requests
        suspense: false,
      }}
    >
      {children}
    </SWRConfig>
  )
}
